import React from 'react';
import ServiceCategoryPage from './ServiceCategoryPage';

const VisaMedicalCertificates = () => {
  return (
    <ServiceCategoryPage
      category="Visa Medical Certificates"
      title="Visa Medical Certificates"
      intro="Get a same-day medical certificate for your visa application. Our UK-based doctors provide verifiable certificates for a wide range of countries."
    />
  );
};

export default VisaMedicalCertificates;